export default __webpack_public_path__ + "7f37350ebbeaa27693b3b07aaf11c0b8.svg";